import { computed, inject } from 'vue';
import { builderStateKey, formBuilderServiceKey } from 'src/utilities/injection-keys';
import { findFieldByIdentity, isFieldType, isInsideRepeatingContainer, toContainerNameScope, toFieldSetId } from '@cognitoforms/form-builder';
import { FieldType } from '@cognitoforms/types/server-types/core/model/forms/definition/field-type';
import type { SignatureField } from '@cognitoforms/types/server-types/core/model/forms/definition/signature-field';
import session from '@cognitoforms/api/services/session';

export const useSelectedSignatureField = () => {
	const builder = inject(formBuilderServiceKey)!;
	const builderState = inject(builderStateKey)!;

	const documentSigningEnabled = () => !!session.value?.enabledFeatures?.DocumentSigning;

	const fieldSetId = computed(() => toFieldSetId(builder.form.RootFieldSetId, builderState.selectedField?.containerIndexes));

	const nameScope = computed(() => toContainerNameScope(builder.form, builderState.selectedField?.containerIndexes));

	const selectedField = computed(() => findFieldByIdentity(builder.form, fieldSetId.value, builderState.selectedField?.fieldIndex));

	const signatureField = computed(() => {
		const field = selectedField.value;
		if (!documentSigningEnabled() || !field || !isFieldType<SignatureField>(field, FieldType.Signature))
			return undefined;

		return field;
	});

	const insideRepeatingContainer = computed(() =>
		isInsideRepeatingContainer(builder.form, builderState.selectedField?.containerIndexes));

	return { fieldSetId, nameScope, signatureField, insideRepeatingContainer };
};
